import React from 'react';
import { ChatThread } from './Chat';

interface ChatSidebarProps {
  threads: ChatThread[];
  selectedThread: number | null;
  editingThread: ChatThread | null;
  onThreadSelect: (threadId: number) => void;
  onNewThread: () => void;
  onEditThread: (thread: ChatThread) => void;
  onUpdateThread: (threadId: number, newName: string) => void;
  onDeleteThread: (threadId: number) => void;
}

const ChatSidebar: React.FC<ChatSidebarProps> = ({
  threads,
  selectedThread,
  editingThread,
  onThreadSelect,
  onNewThread,
  onEditThread,
  onUpdateThread,
  onDeleteThread,
}) => {
  return (
    <div className="w-64 bg-gray-50 dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700">
      <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
        <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200">Threads</h2>
        <button
          onClick={onNewThread}
          className="px-2 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          + New
        </button>
      </div>
      <div className="overflow-y-auto">
        {threads.map((thread) => (
          <div
            key={thread.id}
            className={`p-4 cursor-pointer ${
              selectedThread === thread.id
                ? 'bg-gray-200 dark:bg-gray-700'
                : 'hover:bg-gray-100 dark:hover:bg-gray-700'
            } relative group`}
          >
            <div onClick={() => onThreadSelect(thread.id)}>
              {editingThread?.id === thread.id ? (
                <input
                  type="text"
                  value={editingThread.name}
                  onChange={(e) => onEditThread({ ...editingThread, name: e.target.value })}
                  onBlur={() => onUpdateThread(thread.id, editingThread.name)}
                  className="w-full p-1 rounded bg-white dark:bg-gray-600 text-gray-800 dark:text-gray-200"
                  autoFocus
                />
              ) : (
                <>
                  <h3 className="font-medium text-gray-800 dark:text-gray-200">{thread.name}</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400 truncate">{thread.last_message}</p>
                  <span className="text-xs text-gray-500 dark:text-gray-400">{thread.updated_at}</span>
                </>
              )}
            </div>
            <div className="absolute right-2 top-2 hidden group-hover:flex space-x-2">
              <button
                onClick={() => onEditThread(thread)}
                className="p-1 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
              >
                ✏️
              </button>
              <button
                onClick={() => onDeleteThread(thread.id)}
                className="p-1 text-gray-500 dark:text-gray-400 hover:text-red-600"
              >
                🗑️
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChatSidebar;
